var React = require('react');

function Hamburger (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#fff"},[React.createElement("rect",{"height":"3.33333","rx":"1.66667","width":"22.2222","y":"11.6667","key":0}),React.createElement("rect",{"height":"3.33333","rx":"1.66667","width":"22.2222","y":"18.3335","key":1}),React.createElement("rect",{"height":"3.33333","rx":"1.66667","width":"22.22","y":"25","key":2})]));
}

Hamburger.defaultProps = {"fill":"none","height":"40","viewBox":"0 0 23 40","width":"23"};

module.exports = Hamburger;

Hamburger.default = Hamburger;
